import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { runnerViewAll } from '../../docs-routes'

const RunHistorySourceDescription = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      Indicates how the run was triggered: manually in DAI, by DAI schedule, or via the CLI.
      <br />
      <br />
      Runs created before the source data was added to DAI will be empty in this column.
    </Color>
    <DocusaurusFooter path={runnerViewAll} />
  </Paragraph>

export default RunHistorySourceDescription
